module.exports = __webpack_public_path__ + "static/media/runpaisa.348e2619.png";